import { Injectable } from '@angular/core';
import { AppstorageTsService } from '../appstorage/appstorage.ts.service';
import { Platform } from '@ionic/angular';
import { ConfigService } from '../config/config.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { UserSessionService } from '../user-session/user-session.service';
import { LogoutService } from '../logout/logout.service';
import { MobileToolsService } from '../mobile-tools/mobile-tools.service';

@Injectable({
  providedIn: "root",
})
export class SiteLocationService {

  statesMap: { [key: string]: string } = {
    'PA': 'Pennsylvania',
    'NJ': 'New Jersey',
    'ON': 'Ontario',
  }

  statesRgLogoMap: { [key: string]: string } = {
    'Pennsylvania': 'imgs/rg_pa.svg',
    'New Jersey': 'imgs/rglogo.svg',
    'Ontario': 'imgs/rg_on.svg',
  }

  constructor(
    private platform: Platform,
    private appstorageTsService: AppstorageTsService,
    private navigator: Navigator,
    private config: ConfigService,
    public userSession: UserSessionService,
    private mobileTools: MobileToolsService,
    private logoutService: LogoutService
  ) { }


  public goTo(url?, stateCode?, environment?) {
    console.log("SiteLocationService goTo", url, stateCode, environment)
    if (this.platform.is("capacitor")) {
      this.appstorageTsService.setJurisdiction(stateCode).then(() => {
        this.config.reloadConfig(environment).then(() => {
          return setTimeout(() => {
            console.log("skin: jurisdiction change ", stateCode);
            this.navigator.navigateToCasinoReplacingHistory();

            this.mobileTools.checkRestrictedPlayStore().then(() => {
              console.log("show play store restricted?", this.mobileTools.shouldRestrictPlayStore)

              if (!this.mobileTools.shouldRestrictPlayStore) {
                this.mobileTools.checkForUpdate().then(() => {
                  console.log("show update?", this.mobileTools.shouldUpdate)
                })
              }
            })

          }, 1000);
        });
      });
    } else {
      this.appstorageTsService.setWebSplashSelection(stateCode);
      //check storage value for web if it's updated based on user selection from left sidemenu selection
      this.appstorageTsService.getWebSplashSelection().then((stateValue) => {
        console.log('----stateValue----', stateValue)
      })
      return window.location.replace(url);
    }
  }

  changeState(url, stateCode) {
    const isAuthenticated = this.userSession.isAuthenticated();

    if (this.platform.is("capacitor")) {
      this.appstorageTsService.setJurisdiction(stateCode).then(() => {
        if (!isAuthenticated) {
          this.navigator.toLandingPage(true);
        }
      });
    }

    if (isAuthenticated) {
      this.logoutService.callLogout();
    }

    if (!this.platform.is("capacitor")) {
      setTimeout(() => {
        this.goTo(url, stateCode);
      }, 1000);
    }
  }
}
